import { render, staticRenderFns } from "./empty_file.vue?vue&type=template&id=eb6d3530&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "empty_file.vue"
export default component.exports